<template lang="pug">
div
  el-row(:gutter="12")
    el-col(v-for="(card,index) of cards" :key="index" :span="8")
      el-card.card(shadow="hover")
        span.name  {{card.name}}
        span.value {{data[card.key] || 0}}
  el-row(:gutter="12")
    el-col(:span="12")
      el-card
        template(slot="header") 版本更新
        | 无更新
    el-col(:span="12")
      el-card
        template(slot="header") FAQ
        | FAQ占位
</template>

<script>
export default {
  data() {
    return {
      cards: [
        {
          name: '今日新订单',
          key: 'order_day'
        },
        {
          name: '今日新产品',
          key: 'product_day'
        },
        {
          name: '总订单数',
          key: 'order_count'
        },
        {
          name: '今日新建站',
          key: 'commodity_day'
        },
        {
          name: '产品中心',
          key: 'product_count'
        },
        {
          name: '建站中心',
          key: 'commodity_count'
        }
      ],
      data: {}
    }
  },
  async mounted() {
    let res = await this.$api.GetIndex()
    this.data = res
    console.log(res)
  }
}
</script>

<style lang="less" scoped>

.el-row {
  margin-bottom: 30px;
}

.el-col {
  margin-bottom: 12px;
}

.card {
  /deep/ .el-card__body {
    display:flex;
    justify-content: space-between;
  }
}
</style>